/** The address of the import's pages (2.B-2 provides; 2.Q's journeys and OPS 3 link to it). */
export function importHref(runId?: string): string {
  return runId === undefined ? '/import' : `/import/${encodeURIComponent(runId)}`;
}

/** Import history (stage s3). */
export const HISTORY_HREF = '/import/history';
